export default "__VITE_ASSET__CJNuFVM1__"